<template>
  <div>
    <div v-if="display" class="v-overlay v-overlay--active internal-overlay" style="z-index: 801;"></div>
    <div class="text-xs-center">
      <v-dialog
          :value="display"
          width="500"
          :persistent="true"
      >
        <v-card>
          <v-toolbar card dark color="primary">
            <v-toolbar-title>{{ 'app.test_subscription_extension.extend_title' | trans }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark small @click="close">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            {{ 'app.test_subscription_extension.use_button' | trans }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="close">
              {{ 'app.close' | trans }}
            </v-btn>
            <v-btn color="primary" :href="'/subscription/extension'">
              {{ 'app.test_subscription_extension.extend' | trans }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    is_able_to_extend_test_subscription: {
      type: Boolean
    }
  },
  data: function () {
    return {
      display: false
    };
  },
  mounted() {
    this.display = this.is_able_to_extend_test_subscription;
    if (this.display) {
      axios.post('/notification-register', {register_type: 'extend_test_subscription', 'days_between': 30});
      setTimeout(() => {
        const overlayFromOtherVueInstance = document.querySelector('div.v-overlay.v-overlay--active:not(.internal-overlay)');
        if (overlayFromOtherVueInstance) {
          overlayFromOtherVueInstance.style.display = 'none';
        }
      }, 1000);
    }
  },
  methods: {
    close: function () {
      this.display = false;
    }
  }
}
</script>
